/** Mask email: ci**********@demo.com */
export function maskEmail(email?: string) {
  if (!email) return '—';
  const [user, domain] = email.split('@');
  if (!domain) return email;
  const visible = user.slice(0, 2);
  const hidden = '*'.repeat(Math.max(8, user.length - 2));
  return `${visible}${hidden}@${domain}`;
}

/** Mask phone: +9*********02 */
export function maskPhone(phone?: string) {
  if (!phone) return '—';
  if (phone.length <= 4) return phone;
  const head = phone.slice(0, 2);
  const tail = phone.slice(-2);
  const hidden = '*'.repeat(Math.max(9, phone.length - 4));
  return `${head}${hidden}${tail}`;
}

export function formatEmail(email: string | undefined, mask: boolean) {
  return mask ? maskEmail(email) : (email || '—');
}

export function formatPhone(phone: string | undefined, mask: boolean) {
  return mask ? maskPhone(phone) : (phone || '—');
}
